import React, { ReactNode, useState } from 'react';
import Sidebar from './Sidebar/Sidebar';
import Navbar from './Navbar/Navbar';

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [isSidebarPinned, setIsSidebarPinned] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarPinned((current) => !current);
  };

  return (
    <>
      <Sidebar isSidebarPinned={isSidebarPinned} onToggleSidebar={toggleSidebar} />
      <Navbar changNavbar={isSidebarPinned} onToggleSidebarInNavbar={toggleSidebar} />
      <div className={`content-page ${isSidebarPinned ? "content-page-push" : "content-page-pool"}`}>
        <div className="container-fluid">
          <div className="col-lg-12 m-0 p-0">{children}</div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
